import { render, staticRenderFns } from "./chartDept.vue?vue&type=template&id=358da706&scoped=true&"
import script from "./chartDept.vue?vue&type=script&lang=js&"
export * from "./chartDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358da706",
  null
  
)

export default component.exports